import { request } from './request'

export const getXeroStatus = () => request({ url: 'xero/status', method: 'GET' })

export const getXeroConnectUrl = () => request({ url: 'xero/connect', method: 'GET' })

export const disconnectXero = () => request({ url: 'xero/disconnect', method: 'DELETE' })
